var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_887_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23718 7.00047L13.7436 1.49462C14.0854 1.15281 14.0854 0.598629 13.7436 0.256846C13.4018 -0.0849643 12.8476 -0.0849643 12.5059 0.256846L6.99998 5.76327L1.49413 0.256846C1.15232 -0.0849643 0.598141 -0.0849643 0.256358 0.256846C-0.0854252 0.598656 -0.0854525 1.15284 0.256358 1.49462L5.76278 7.00047L0.256358 12.5063C-0.0854525 12.8482 -0.0854525 13.4023 0.256358 13.7441C0.598168 14.0859 1.15235 14.0859 1.49413 13.7441L6.99998 8.23767L12.5058 13.7441C12.8476 14.0859 13.4018 14.0859 13.7436 13.7441C14.0854 13.4023 14.0854 12.8481 13.7436 12.5063L8.23718 7.00047Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_887_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.6bd934423cc5793a74f8547436ff48d5.svg";
export { ForwardRef as ReactComponent };